import {Pipe, PipeTransform} from '@angular/core';

const FILE_SIZE_UNITS = ['O', 'Ko', 'Mo'];

@Pipe({
    name: 'formatFileSize'
})
export class FormatFileSizePipe implements PipeTransform {

    transform(sizeInBytes: number): string {

        /**
         * We are looking for power (0 < power < 3) as:
         * sizeInBytes = 1024^power
         * <=> ln(sizeInBytes) = ln(1024^power)
         * <=> ln(sizeInBytes) = power*ln(1024)
         * <=> power = ln(sizeInBytes)/ln(1024)
         */
        let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, FILE_SIZE_UNITS.length - 1);

        const size = sizeInBytes / Math.pow(1024, power); // size in new units
        const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        const unit = FILE_SIZE_UNITS[power];

        return `${formattedSize} ${unit}`.replace('.', ',');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/format-file-size.pipe.ts